export { CompletionCelebration } from "@/components/deals/completion/CompletionCelebration";
export { TransactionSummary } from "@/components/deals/completion/TransactionSummary";
export { DocumentDownloads } from "@/components/deals/completion/DocumentDownloads";
export { CompletionStep } from "@/components/deals/completion/CompletionStep";
